export default __webpack_public_path__ + "static/media/CarmenOverture-Bizet.4f6983ce.mp3";